import type { ColumnType } from 'antd/es/table';
import {
    formatSearchVolume,
    formatSearchVolumeTag,
    formatPercent,
    formatPercentTag,
    formatNumber,
    searchVolumeSorter,
    renderOpportunityScore,
    opportunityScoreSorter,
    renderAsinShare,
} from '../formatters';

/**
 * 机会词挖掘 - 高优先级列
 */
export const highPriorityOpportunityColumns: ColumnType<any>[] = [
    {
        title: '搜索词',
        dataIndex: 'search_query',
        key: 'search_query',
        width: 200,
    },
    {
        title: '搜索量',
        dataIndex: 'search_volume',
        key: 'search_volume',
        width: 90,
        render: formatSearchVolumeTag,
        sorter: searchVolumeSorter,
    },
    {
        title: '大盘转化率',
        dataIndex: 'market_cvr',
        key: 'market_cvr',
        render: (val: number) => formatPercentTag(val, 'volcano'),
    },
    {
        title: '大盘点击率',
        dataIndex: 'market_ctr',
        key: 'market_ctr',
        render: formatPercent,
    },
    {
        title: '曝光量',
        dataIndex: 'impressions',
        key: 'impressions',
        render: formatNumber,
    },
    {
        title: 'ASIN占比',
        dataIndex: 'asin_share',
        key: 'asin_share',
        render: renderAsinShare,
    },
    {
        title: '机会评分',
        dataIndex: 'opportunity_score',
        key: 'opportunity_score',
        render: renderOpportunityScore,
        sorter: opportunityScoreSorter,
    },
];

/**
 * 机会词挖掘 - 中等优先级列
 */
export const mediumPriorityOpportunityColumns: ColumnType<any>[] = [
    {
        title: '搜索词',
        dataIndex: 'search_query',
        key: 'search_query',
        width: 200,
    },
    {
        title: '搜索量',
        dataIndex: 'search_volume',
        key: 'search_volume',
        width: 90,
        render: formatSearchVolume,
        sorter: searchVolumeSorter,
    },
    {
        title: '大盘转化率',
        dataIndex: 'market_cvr',
        key: 'market_cvr',
        render: formatPercent,
    },
    {
        title: '曝光量',
        dataIndex: 'impressions',
        key: 'impressions',
        render: formatNumber,
    },
    {
        title: 'ASIN占比',
        dataIndex: 'asin_share',
        key: 'asin_share',
        render: formatPercent,
    },
];
